import { gql } from '@apollo/client';

export const BENCHMARK_EXPORT = gql`
  query BenchmarkExport($organizationId: Long!, $from: Date!, $to: Date!) {
    benchmarkExport(organizationId: $organizationId, from: $from, to: $to) {
      payload
      fileName
      caseCount
    }
  }
`;

export function exportRange(fromMonth: string, toMonth: string) {
  const valid = (m: string) => /^\d{4}-(0[1-9]|1[0-2])$/.test(m);
  if (!valid(fromMonth) || !valid(toMonth)) throw new Error('Choose a start and end month.');
  const [fy, fm] = fromMonth.split('-').map(Number);
  const [ty, tm] = toMonth.split('-').map(Number);
  const months = (ty - fy) * 12 + tm - fm + 1;
  if (months < 1 || months > 3) throw new Error('Choose one to three calendar months.');
  return { from: `${fromMonth}-01`, to: new Date(Date.UTC(ty, tm, 0)).toISOString().slice(0, 10) };
}

export function downloadExport(payload: string, fileName: string) {
  if (!/^benchmark-\d+-\d{4}-\d{2}-\d{2}_\d{4}-\d{2}-\d{2}\.json\.gz$/.test(fileName)) {
    throw new Error('Unexpected benchmark filename.');
  }
  const bytes = Uint8Array.from(atob(payload), c => c.charCodeAt(0));
  if (bytes[0] !== 0x1f || bytes[1] !== 0x8b) throw new Error('Invalid benchmark download.');
  const url = URL.createObjectURL(new Blob([bytes], { type: 'application/gzip' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
